(function () {
  function onReady(callback) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", callback);
      return;
    }

    callback();
  }

  function wrapTables(root) {
    Array.prototype.slice.call(root.querySelectorAll("table")).forEach(function (table) {
      var parent = table.parentElement;
      if (parent && parent.classList.contains("bn-page-content__table-wrap")) return;

      var wrapper = document.createElement("div");
      wrapper.className = "bn-page-content__table-wrap";
      table.parentNode.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    });
  }

  onReady(function () {
    Array.prototype.slice.call(document.querySelectorAll("[data-bn-page-content]")).forEach(wrapTables);
  });
})();
